import { ColumnModel, Attributes } from '@leverege/ui-attributes';
import ImageColumnModel from "../../models/ImageColumnModel.js";
/* Initialize Constants */
const VALUE_TYPE = 'resourceImage@';
const TYPE = `attr.column.${VALUE_TYPE}`;

/**
 * Gets name from data.
 */
function getName(data) {
  return Attributes.getDisplayName(data.attrName, data.objectType);
}

/* Initialize Model Base */
const base = {
  ...ImageColumnModel,
  getName
};
delete base.create;
delete base.TYPE;
const dModel = {
  cell: {
    variant: 'viewImages'
  },
  dialog: {
    objectFit: 'contain',
    titleIcon: 'https://storage.googleapis.com/molten-ui-assets/screen-icons/icon-multi-image-title.svg',
    imageWidth: 718,
    imageHeight: 525
  }
};

/**
 * Creates an attribute detail model instance.
 */
function create(attrName, objectType) {
  const m = ColumnModel.create(TYPE, {
    attrName,
    objectType,
    ...dModel
  });
  m.popup = {};
  return m;
}

/* Export Modules */
export default {
  TYPE,
  create,
  ...base
};